import DOMPurify from 'dompurify';

export const sanitizeHtmlContent = (htmlContent) => {
  const sanitizedHtml = DOMPurify.sanitize(htmlContent);
  return { __html: sanitizedHtml };
};

export const getPreviewToRecipients = (mailItem) => {
  const isSent = mailItem?.is_sent ?? false;
  const members = isSent ? mailItem?.email_members ?? [] : (mailItem?.email_members ?? []).filter((member) => !member.is_sender);

  const ccBccEmails = new Set(
    [...(mailItem?.cc_list ?? []), ...(mailItem?.bcc_list ?? [])].map((email) => email?.trim()?.toLowerCase()).filter(Boolean)
  );

  if (ccBccEmails.size === 0) {
    return members;
  }

  return members.filter((member) => {
    const email = member?.user_email?.trim()?.toLowerCase();
    return email && !ccBccEmails.has(email);
  });
};
